import '../../../App.css'

const CardMeter1 = () => {

    return (
        <>
            <div className='bg-[#fff] h-[450px] overflow-auto'>
                <div className="">
                    <div id="rulesList___BV_modal_body_" className="modal-body">
                        <div id="rulesBoxContainer">
                            <div>
                                <p>
                                    <img src='../rulesImg/1cardmeter.webp' />
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )

}
export default CardMeter1